// extracted by mini-css-extract-plugin
export default {"skills":"skills_skills__J+Y6l","skills_container":"skills_skills_container__cYEGZ","isVisible":"skills_isVisible__TpVXz"};